import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, Badge, statusTone, Money, StatCard } from "@/components/common";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export async function downloadStatement() {
  try {
    const { data } = await api.get("/franchise/institute/statement.csv", { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url; a.download = "viriks-institute-statement.csv"; a.click();
    URL.revokeObjectURL(url);
  } catch { toast.error("Could not download statement"); }
}

export default function InstituteCommissions() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/franchise/institute/ledger").then(({ data }) => setD(data)); }, []);
  if (!d) return null;
  return (
    <div data-testid="institute-commissions">
      <PageHeader title="Earnings Ledger" subtitle="Every commission and course-sale earning credited to you" action={<Button variant="outline" onClick={downloadStatement} data-testid="inst-statement"><Download size={15} className="mr-1" /> Download statement</Button>} />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <StatCard label="Eligible (confirmed)" value={<Money amount={d.eligible} />} testid="ledger-eligible" />
        <StatCard label="Pending confirmation" value={<Money amount={d.pending} />} testid="ledger-pending" />
        <StatCard label="Withdrawn" value={<Money amount={d.withdrawn} />} testid="ledger-withdrawn" />
        <StatCard label="Available balance" value={<Money amount={d.available_balance} />} testid="ledger-balance" />
      </div>
      <div className="bg-white border border-border rounded-lg overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead className="bg-muted/40 text-xs uppercase text-muted-foreground"><tr>{["Date", "Course", "Sale amount", "Share", "Commission", "Status"].map((h) => <th key={h} className="text-left px-4 py-3 font-semibold">{h}</th>)}</tr></thead>
          <tbody>
            {d.transactions.length === 0 && <tr><td colSpan={6} className="px-4 py-8 text-center text-muted-foreground">No commissions yet.</td></tr>}
            {d.transactions.map((t) => (
              <tr key={t.id} className="border-t border-border" data-testid={`ledger-row-${t.id}`}>
                <td className="px-4 py-3">{new Date(t.created_at).toLocaleDateString("en-IN")}</td>
                <td className="px-4 py-3">{t.course_title}</td>
                <td className="px-4 py-3"><Money amount={t.sale_amount} /></td>
                <td className="px-4 py-3">{t.percent}%</td>
                <td className="px-4 py-3 font-semibold"><Money amount={t.amount} /></td>
                <td className="px-4 py-3"><Badge tone={statusTone(t.status)}>{t.status === "available" ? "eligible" : t.status}</Badge></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
